// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-bar-container-paq7L {
  display: flex;
  overflow-x: auto;
}

.tab-bar-container-paq7L::-webkit-scrollbar {
  display: none;
}

.tab-bar-tab_container-xGrzy {
  padding: 16px 32px 0px;
}

.tab-bar-tab_container-xGrzy:first-child {
  padding-left: 20px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/tab-bar/tab-bar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  overflow-x: auto;\n}\n\n.container::-webkit-scrollbar {\n  display: none;\n}\n\n.tab_container {\n  padding: 16px 32px 0px;\n}\n\n.tab_container:first-child {\n  padding-left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tab-bar-container-paq7L`,
	"tab_container": `tab-bar-tab_container-xGrzy`
};
export default ___CSS_LOADER_EXPORT___;
